module.exports = __webpack_public_path__ + "img/744.26b76504.jpg";